module.exports = __webpack_public_path__ + "static/desktop/img/case7.6542d413.jpg";